<template>
  <a-layout class="vb__layout">
    <a-layout-content>
      <div
        :class="{
          [$style.container]: true,
          vb__layout__squaredBorders: settings.isSquaredBorders,
          vb__layout__cardsShadow: settings.isCardShadow,
          vb__layout__borderless: settings.isBorderless,
          [$style.white]: settings.authPagesColor === 'white',
          [$style.gray]: settings.authPagesColor === 'gray',
        }"
        :style="{
          backgroundImage:
            settings.authPagesColor === 'image'
              ? `url(${backgroundImage})`
              : 'none',
        }"
      >
        <div
          :class="{
            [$style.topbar]: true,
            [$style.topbarGray]: settings.isGrayTopbar,
          }"
        >
          <div :class="$style.logoContainer">
            <div :class="$style.logo">
              <img
                width="120"
                :src="logoImage"
                alt="Carta Porte Holcim"
              >
              <div :class="$style.name">
                Carta Porte Holcim
              </div>
            </div>
          </div>
        </div>
        <div class="mb-5">
          <router-view v-slot="{ Component }">
            <transition :name="settings.routerAnimation" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
        <div class="mt-auto pb-5 pt-5">
          <div class="text-center">
            Copyright © {{ new Date().getFullYear() }}
            Carta Porte
            |
            <a href="https://www.holcim.com.mx/" target="_blank" rel="noopener noreferrer">
              Holcim México
            </a>
          </div>
        </div>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { getBrandingImagePath, getPublicAssetPath } from '@/utils/assets';
import { mapState } from 'vuex';

export default {
  name: 'AuthLayout',
  computed: {
    ...mapState(['settings']),
    backgroundImage() {
      return getPublicAssetPath('resources/images/content/photos/8.jpeg');
    },
    logoImage() {
      return getBrandingImagePath('holcim_logo.png');
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
